import { forwardRef, type MouseEvent as ReactMouseEvent } from 'react'
import { useTranslation } from 'react-i18next'
import {
  KibThumbdownFillIcon,
  KibThumbdownOutlineIcon,
  KibThumbupFillIcon,
  KibThumbupOutlineIcon,
} from '@chewy/kib-icons-react'
import classNames from 'classnames'

import RhapTextButton from '~/components/common/RhapTextButton'

import '@chewy/kib-controls-styles/dist/styles/kib-button-new.css'
import styles from './RhapFeedbackButton.module.scss'

export enum FeedbackType {
  POSITIVE = 'positive',
  NEGATIVE = 'negative',
}

export interface RhapFeedbackButtonProps {
  className?: string
  disabled?: boolean
  isSelected?: boolean
  onClick?: (event: ReactMouseEvent<HTMLButtonElement>) => void
  type: FeedbackType
}

const RhapFeedbackButton = forwardRef<
  HTMLButtonElement,
  RhapFeedbackButtonProps
>(({ className, disabled, isSelected = false, onClick, type }, ref) => {
  const { t } = useTranslation('Agent')

  const isPositive = type === FeedbackType.POSITIVE
  const label = isPositive
    ? t('Agent:FEEDBACK_POSITIVE')
    : t('Agent:FEEDBACK_NEGATIVE')

  const icon = isPositive ? (
    isSelected ? (
      <KibThumbupFillIcon />
    ) : (
      <KibThumbupOutlineIcon />
    )
  ) : isSelected ? (
    <KibThumbdownFillIcon />
  ) : (
    <KibThumbdownOutlineIcon />
  )

  return (
    <RhapTextButton
      iconOnly
      aria-label={label}
      className={classNames(
        styles.feedbackButton,
        { [styles.feedbackButtonSelected]: isSelected },
        className,
      )}
      disabled={disabled}
      emphasis={isSelected ? 'primary' : undefined}
      icon={icon}
      ref={ref}
      size="small"
      theme={isSelected ? 'action' : 'utility'}
      title={label}
      onClick={onClick}
    />
  )
})

RhapFeedbackButton.displayName = 'RhapFeedbackButton'

export default RhapFeedbackButton
